const ContactWidgetStyles = {
    root: {
        "&.MuiInputLabel-root": {
            color: "#36393D",
            fontWeight: 'normal',
            fontSize: '14px',
            marginTop: '-7px',
            "&.Mui-focused": {
                color: '#ccc',
            },
            "&.MuiFormLabel-filled:not(.Mui-focused)": {
                color: '#ccc',
            },
        },
        "&.MuiInputLabel-root span": {
            display: 'none'
        },
        "&.MuiInputLabel-root.Mui-error": {
            color: 'red',
        },
        "&.MuiInputLabel-root.Mui-error span": {
            display: 'inline',
            color: 'red',
            paddingLeft: '5px',
            fontWeight: 'normal',
        },
        "&.MuiInputLabel-shrink": {
            transform: 'translate(0px, 13px) scale(0.90)',
        },
        '&.MuiInputBase-root': {
            fontSize: '14px',
        },
        "&.MuiInput-underline:hover:not(.Mui-disabled):before":{
            borderBottom: '2px solid #a8a8a8'
        },
        "&.MuiInput-underline:before": {
            borderBottom: '1px solid #f2f3f4'
        },
        "&.MuiInput-underline:after": {
            borderBottom: '1px solid #a8a8a8'
        },
        "&.isKeywordSearch": {
            padding: "0 0 10px",
            fontSize: '16px'
        },
        '& .MuiListItem-root': {
            display: 'none',
        }
    },
    '@global': {
        'input[type="search"]::-webkit-search-cancel-button': {
            '-webkit-appearance': 'none',
        },
    },
    backdrop: {
        zIndex: 999,
        color: '#fff',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
    profileListItem: props => ({
        '&:hover': {
            background: props.accentColor,
            color: '#fff',
        },
        '&:hover .MuiTypography-root': {
            color: '#fff',
        },
        '& .list-result-match': {
            fontWeight: 'bold',
            color: '#000',
        },
        '&:hover .list-result-match': {
            fontWeight: 'bold',
            color: '#fff',
        }
    }),
    profileListItemTypography: {
        fontSize: '14px',
    },
    termsLink: {
        textDecoration: 'none',
        color: '#36393D',
        cursor: 'pointer',
        "&:hover": {
            textDecoration: 'underline'
        }
    },
    footerLogo: {
        cursor: 'pointer'
    },
    footerContainer: {
        display: 'flex',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        fontSize: '11px',
    },
    smsPrivacyPolicyContainer: props =>  ({
        height: props.isMobile ? 'calc(100vh - 123px)' : '470px',
        overflowY: 'scroll',
        fontSize: '18px',
        textAlign: 'left',
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: '22px',
        '& h2, & h3': {
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '0',
            paddingBottom: '0',
            marginTop: '18px',

        },
        '& h3': {
            fontSize: '16px',
            marginTop: '6px',
        },
        '& p': {
            marginTop: '0',
            marginBottom: '0',
            paddingBottom: '14px',
        },
        '& ul': {
            margin: 0,
            paddingBottom: '10px',
        },
        '& li': {
            paddingBottom: '6px',
        }
    }),
    searchResults: props => ({
        maxHeight: props.isMobile ? 'calc(100vh - 300px)' : '320px',
        overflowY: "scroll",
        width: 'calc(100% + 20px)',
        marginLeft: '-10px',
        scrollbarWidth: "none", // Firefox
        "-ms-overflow-style": "none",  // IE 10+
        "&::-webkit-scrollbar": { // Webkit
            width: "0"
        }
    }),
    textArea: {
        "& .MuiInputBase-input": {
            fontSize: '14px',
        },
        "& .MuiFormLabel-root": {
            color: "#36393D",
            fontWeight: '800',
            fontSize: '14px',
            marginTop: '-7px'
        },
        "& .MuiInputLabel-shrink": {
            transform: 'translate(0px, 13px) scale(0.90)',
        },
        "&.MuiInput-underline:hover:not(.Mui-disabled):before":{
            borderBottom: '2px solid #a8a8a8'
        },
        "&.MuiInput-underline:before": {
            borderBottom: '1px solid #f2f3f4'
        },
        "&.MuiInput-underline:after": {
            borderBottom: '1px solid #a8a8a8'
        }
    },
    button: props => ({
        ... {
            position: 'fixed',
            zIndex: '99999999',
            left: props.isLeftAligned ? '30px' : 'initial',
            right: props.isLeftAligned ? 'initial' : '30px',
            bottom: '30px',
            background: '#FFFFFF',
            border: '2px solid #FAFAFA',
            boxShadow: '0px 8px 25px rgba(25, 38, 57, 0.2), 0px 4px 8px rgba(25, 38, 57, 0.07)',
            borderRadius: '26.5px',
            flexDirection: 'row',
            width: props.isIconOnly ? 'auto' : props?.primaryCtaWidth ?? '192px',
            paddingLeft: props.isIconOnly ? 'unset' : 'inherit',
            minWidth: props.isIconOnly ? 'auto' : 'initial',
            maxHeight: '54px',
            justifyContent: 'space-between',
            '&.MuiButton-root:hover':{
                background: "rgba(255, 255, 255, 0.9)"
            },
            '& .MuiButton-label': {
                width: props?.primaryCtaWidth ?? '192px',
            }
        },
        ... {
            '&.is-highlight-button': {
                background: props.accentColor,
                borderColor: props.accentColor,
                maxHeight: '80px',
                height: '80px',
                alignItems: 'flex-start',
                zIndex: '99999998',
                boxShadow: 'none',
                lineHeight: '20px',
                paddingTop: '1px',
            },
            '&.is-highlight-button:hover': {
                background: props.accentColor,
            },
            '&.is-highlight-button .MuiButton-label': {
                color: '#ffffff',
                fontSize: '10px',
                fontWeight: '700',
                letterSpacing: 'normal',
                paddingLeft: 0,
                paddingRight: '0',
                textTransform: 'uppercase',
            }
        },
        ... props.isIconOnly && {
            '& .MuiButton-label': {
                width: 'auto',
                paddingLeft: 'unset',
                paddingRight: 'unset',
                minWidth: 'auto',
            }
        },
    }),
    highlight_icon: {
        fontSize: '18px',
        marginRight: '3px',
    },
    highlight_button_container: props => ({
        overflow: 'hidden',
        width:  props?.primaryCtaWidth ?? '192px',
        height: '80px',
        position: 'fixed',
        right: props.isLeftAligned ? 'initial' : '30px',
        left: props.isLeftAligned ? '30px' : 'initial',
        bottom: '30px',
        borderRadius: '26.5px'
    }),
    channel_button: {
        color: '#ffffff',
        fontSize: '14px',
        letterSpacing: '0.5px',
        fontFamily: 'Nunito',
        fontWeight: "600",
        justifyContent: 'center',
    },
    button__label: props => ({
        color: '#2B2E31',
        paddingLeft: props.isLeftAligned ? '0px' : '12px',
        fontSize: '16px',
        letterSpacing: '3.55px',
        lineHeight: '22px',
        fontFamily: 'Nunito',
        fontWeight: "600",
        flexDirection: props.isLeftAligned ? 'row-reverse' : 'row',
        paddingRight: props.isLeftAligned ? '12px' : '0',
    }),
    button_small: props => ({
        position: 'fixed',
        left: props.isLeftAligned ? '30px' : 'initial',
        right: props.isLeftAligned ? 'initial' : '30px',
        bottom: props.isShowHighlight ? '125px' : '90px',
        boxShadow: '0px 4px 8px rgba(25, 38, 57, 0.2), 0px 4px 8px rgba(25, 38, 57, 0.07)',
        borderRadius: '21px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        maxHeight: '42px',
    }),
    button_small__label: props => ({
        ... {
            color: 'white',
            paddingLeft: props.isLeftAligned ? '0px' : '20px',
            paddingRight: props.isLeftAligned ? '20px' : '0',
            fontSize: '13px',
            letterSpacing: '1.88px',
            lineHeight: '18px',
            fontFamily: 'Nunito',
            fontWeight: "600",
        },
        ... props.isLeftAligned && {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
        }
    }),
    tooltip: props => ({
        position: 'fixed',
        left: props.isLeftAligned ? '30px' : 'initial',
        right: props.isLeftAligned ? 'initial' : '30px',
        bottom: props.isShowHighlight ? '175px' : '140px',
        background: '#D4D3D3',
        borderRadius: '21px',
        flexDirection: 'row',
        maxWidth: '46px',
        maxHeight: '20px',
        justifyContent: 'center',
         '&.MuiButton-root:hover':{
            background: "rgba(212, 211, 211, 0.9)"
        }
    }),
    button__close: props => ({
        minWidth: '57px',
        height: '57px',
        borderRadius: '50%',
        position: 'fixed',
        left: props.isLeftAligned ? '30px' : 'initial',
        right: props.isLeftAligned ? 'initial' : '30px',
        bottom: '30px',
    }),
    buttonClose__text: {
        color: 'white',
        padding: 0,
    },
    tooltip__label: {
        fontSize: '8px',
        lineHeight: '11px',
        fontWeight: "600",
        letterSpacing: '1.78px',
        color: '#616161',
        padding: '5px'
    },
    text: {
        padding: "0",
    },
    buttonIcon: {
        height: '50px',
        width: '30px',
        display: 'flex',
        alignSelf: 'flex-end',
        alignContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '50%',
        paddingLeft: '10px',
        paddingRight: '10px',
        '&.is-empty': {
            width: '0',
        }
    },
    clearFilterTermsIcon: props => ({
        fontSize: '10px',
        padding: '1px',
        color: '#A8A8A8',
        border: '1px solid #A8A8A8',
        borderRadius: '50%',
        marginRight: '4px',
        cursor: 'pointer',
        '&:hover': {
            color: props.accentColor,
            borderColor: props.accentColor,
        }
    }),
    spanText: {
        alignItems: 'center',
        flexGrow: '1',
    },
    form__container: props => ({
        ... {
            zIndex:"10000",
            position: 'fixed',
            left: props.isLeftAligned ? '30px' : 'initial',
            right: props.isLeftAligned ? 'initial' : '30px',
            bottom: '102px',
            width: props.isMobile ? '100vw' : '345px',
            minHeight: '605px',
            background: 'linear-gradient(0deg, rgba(35, 50, 71, 0.06), rgba(35, 50, 71, 0.06)), #FFFFFF',
            boxShadow: '0px 8px 53px rgba(25, 38, 57, 0.2), 0px 4px 8px rgba(25, 38, 57, 0.07)',
            borderRadius: '8px',
            overflow: 'auto',
        },
        ... props.isHideLogo && {
            minHeight: '510px',
        },
        ... props.isMobile && {
            right: '0px',
            left: '0px',
            bottom: '0px',
            width: '100vw',
            minHeight: 'unset',
            borderRadius: '0px',
            maxHeight: 'unset',
            height: '100%',
            overflow: 'hidden'
        }
    }),
    close_mobile: props => (
        {
            display: props.isMobile ? 'inline' : 'none',
        }
    ),
    hide_desktop: props => (
        {
            display: props.isMobile ? 'none' : 'inline-flex',
        }
    ),
    form__inner_container: props => ({
        padding: !props.isHideLogo ? '0 20px' : '0 20px 50px',
        textAlign: 'center',
        position: props.isCallRequestView && 'relative',
        top: props.isCallRequestView && '-38px',
    }),
    header__auto: {
        height: 'auto !important',
        paddingBottom: '24px',
    },
    form__header: props => ({
        ... {
            height: '136px',
            display: 'flex',
            marginBottom: '80px',
            borderTopLeftRadius:  '8px',
            borderTopRightRadius: '8px',
            flexDirection: 'column',
            paddingTop: '24px',
            position: 'relative',
        },
        ... props.isHeaderCondensed && {
            marginBottom: '0',
        },
        ... props.isHideLogo && {
            height: '94px',
            marginBottom: '35px'
        },
        ... props.isMobile && {
            borderTopLeftRadius:  '0px',
            borderTopRightRadius: '0px',
        }
    }),
    headerTitle: props => ({
        fontWeight: 'normal',
        fontSize: '18px',
        '& strong': {
            fontWeight: 800,
        },
        ... props.headerContentStyle === 'small' && {
            marginTop: '4px', // todo - remove this line after the subheadline gets added back in
        }
    }),
    headerContent: props => ({
        ... props.headerContentStyle === 'small' && {
            fontSize: '14px',
            display: 'block',
            lineHeight: '20px',
            width: '246px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
        ... props.isHeaderCondensed && {
            display: 'block',
        }
    }),
    headerBackArrowBox: {
        marginRight: '6px',
    },
    headerBackArrow: {
        color: "#ffffff",
        minWidth: '0',
        padding: '6px',
        marginLeft: '-10px',
    },
    header__text: {
        fontFamily: 'Nunito',
        fontSize: '18px',
        fontWeight: "400",
        lineHeight: '25px',
        color: '#FFFFFF',
        marginRight: '40px',
        paddingLeft: '20px',

    },
    form__body: props => ({
        ... {
            flex: "1",
            alignItems: 'center',
            background: '#FFFFFF',
            borderRadius: '8px',
            paddingTop: '5px',
            paddingBottom: '20px',
            paddingLeft: '12px',
            paddingRight: '12px',
        },
    }),
    call_request_form__body: props => ({
        ... {
            flex: "1",
            alignItems: 'center',
            background: '#FFFFFF',
            borderRadius: '8px',
            paddingTop: '5px',
            paddingBottom: '11px',
            paddingLeft: '12px',
            paddingRight: '12px',
            height: '212px',
            marginTop: '16px',
        },
    }),
    home__body: props => ({
        flex: 1,
        alignItems: 'center',
        background: '#ffffff',
        borderRadius: '8px',
        padding: '25px 28px',
        "&.isCompact": {
            padding: '10px',
            position: 'relative',
            top: !props.isHideLogo ? '-38px' : '0px',
        },
    }),
    form__triangle: props => ({
        ... {
            width: "0",
            height: "0",
            borderTop: '31px solid transparent',
            borderBottom: '31px solid transparent',
            borderRight: '31px solid white',
            alignSelf: 'flex-end',
            margin: '-31px 0 0 auto',
            position: 'absolute',
            right: '20px',
            zIndex: '-1', // ensure the arrow doesn't obscure any content
        },
        ... props.isHeaderCondensed && !props.isHideLogo && {
            margin: '-69px 0 0 auto',
        }
    }),
    form__footer: props => ({
        ... {
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'row',
            padding: '13px 0px',
            justifyContent: 'center',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            position: 'absolute',
            right:' 0px',
            bottom: '0px',
            left: '0px'
        },
        ... (props.isMobile && props.isHideLogo) && {
            position: 'static',
        },
        ... props.isMobile && {
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
        }
    }),
    formfooter__text: {
        fontFamily: 'Nunito',
        fontSize: '11px',
        fontWeight: "300",
        lineHeight: '15px',
        color: '#36393D',
    },
    logo: props => ({
        ... {
            width: '106px',
            height: '106px',
            margin: '15px auto 0 auto',
            backgroundColor: 'white',
            border: '5px solid white',
            alignItems: 'center',
            alignSelf: 'center',
            justifyContent: 'center',
            bottom: '-56px',
            position: 'absolute',
        },
        ... props.isHeaderCondensed && {
            width: '60px',
            height: '60px',
            margin: '0 16px 0 0',
            borderWidth: '2px',
            position: 'static',
        },
        ... props.isHideLogo && {
            display: 'none',
        },
        ... !props.isRectangleLogo && {
            borderRadius: '50%',
            ' img': {
                borderRadius: '50%'
            }
        },
        ... props.isRectangleLogo && !props.isHeaderCondensed && {
            width: '188px',
            height: '106px',
            borderWidth: '5px',
        },
        ... props.isRectangleLogo && props.isHeaderCondensed && {
            width: '80px',
            height: 'auto',
            borderWidth: '4px',
        },
        // '@media (min-width: 600px) and (max-height: 708px)': {
        //     display: 'none'
        // },
        // '@media only screen and (max-width: 340px) ': {
        //     display: 'none'
        // },
    }),
    submit__note: {
        fontFamily: 'Nunito',
        fontSize: '11px',
        fontWeight: "300",
        lineHeight: '15px',
        color: '#36393D',
        marginTop: '8px',
        marginBottom: '0',
        padding:'0 15px',

    },
    sendbutton: {
        borderRadius: '10px',
        width: '87px',
        height: '44px',
        marginBottom: '23px',
        opacity: "1"
    },
    sendbutton__label: {
        color: 'white',
        fontFamily: 'Nunito',
        fontWeight: "800",
        fontSize: '14px'
    },
    sendbutton__disabled: {
        opacity: "0.3"
    },
    callRequestTimeButton: {
        fontSize: '14px',
        lineHeight: '17px',
        minWidth: '70px',
        borderRadius: '20px',
        height: '28px',
        margin: '0 4px 12px 4px',
        border: '1px solid #3C1233',
    },
    callRequestTimeButton__label: {
        fontFamily: 'Nunito',
        fontWeight: '700',
        fontSize: '14px',
        textTransform: 'capitalize',
    },
    isUppercase: {
        textTransform: 'uppercase !important',
    },
    addToContactsButton: {
        borderRadius: '10px',
        height: '44px',
        padding: '6px 16px',
        margin: '12px 0 10px 0'
    },
    addToContactsButton__label: {
        color: 'white',
        fontFamily: 'Nunito',
        fontWeight: "800",
        fontSize: '14px'
    },
    closeCaret__text: props => ({
        ... {
            position: 'absolute',
            right: '0',
            top: '0',
            color: 'rgba(255,255,255,.5)',
            minWidth: '0',
            padding: '10px 10px'
        },
        '&:hover': {
            color: 'rgba(255,255,255)',
        }
    }),
    success__text: {
        fontFamily: 'Nunito',
        fontWeight: "400",
        textAlign: 'center',
        lineHeight: '20px',
        fontSize: '15px',
        padding: '10px'
    },
    error: {
        color: 'red',
        marginBottom: '10px',
        fontWeight: "600",
    },
    errorText: {
        position: 'absolute'
    },
    logo_img: props => ({
        objectFit: 'contain !important',
        ... !props.isRectangleLogo && {
            borderRadius: '50%',
            overflow: 'hidden',
        }
    })
};

export default ContactWidgetStyles;
